import { EpisodeOfCare } from "@medplum/fhirtypes";

import { createEntityAdapter, createSelector, createSlice } from "@reduxjs/toolkit";

import { RootState } from "..";

const episodeOfCareAdapter = createEntityAdapter({
  selectId: (episodeOfCare: EpisodeOfCare) => episodeOfCare.id!,
});

const reducers = {
  loadEpisodeOfCare: episodeOfCareAdapter.setAll,
};

export const episodeOfCareSlice = createSlice({
  name: "episodeOfCare",
  initialState: episodeOfCareAdapter.getInitialState(),
  reducers,
});

export const { loadEpisodeOfCare } = episodeOfCareSlice.actions;

export const selectEpisodeOfCareEntities = (state: RootState) => state.episodeOfCare.entities;

export const selectAllClosedEpisodeOfCare = createSelector(
  [selectEpisodeOfCareEntities],
  (episodeOfCareEntities) =>
    Object.values(episodeOfCareEntities).filter(
      (episodeOfCare) => episodeOfCare.period?.end && episodeOfCare.status !== "cancelled",
    ),
);

export const selectAllActiveEpisodeOfCare = createSelector(
  [selectEpisodeOfCareEntities],
  (episodeOfCareEntities) =>
    Object.values(episodeOfCareEntities).filter(
      (episodeOfCare) => episodeOfCare.status === "active",
    ),
);

export const selectEpisodeOfCareList = createSelector(
  [selectEpisodeOfCareEntities],
  (episodeOfCareEntities) => Object.values(episodeOfCareEntities),
);

export const selectEpisodeOfCare = (id: string) =>
  createSelector(
    [selectEpisodeOfCareEntities],
    (episodeOfCareEntities) => episodeOfCareEntities[id],
  );

export default episodeOfCareSlice.reducer;
